























import { Component } from '@niknevis/vue-modules'
import EntitySearchSelect from '@/modules/common/entity-search/components/shared/EntitySearchSelect.vue'
import { PropSync } from 'vue-property-decorator'
import Vue from 'vue'
import { AdminCampaignApiRoute } from '@/modules/base-campaign/routes/admin-campaign.route'

@Component({
  components: {
    EntitySearchSelect
  }
})
export default class AdminCampaignSearch extends Vue {
  constructor(
    private readonly routes: AdminCampaignApiRoute
  ) {
    super()
  }

  @PropSync('campaignId') campaignIdValue: number

  private get route() {
    return this.routes.baseCampaignSearch()
  }
}
